import { render } from "./make-sales.vue?vue&type=template&id=52304c4a&scoped=true"
import script from "./make-sales.vue?vue&type=script&lang=js"
export * from "./make-sales.vue?vue&type=script&lang=js"

import "./make-sales.vue?vue&type=style&index=0&id=52304c4a&lang=css"
import "./make-sales.vue?vue&type=style&index=1&id=52304c4a&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52304c4a"]])

export default __exports__